import Vue from 'vue'
import Vuex from 'vuex'

// Modules
// eslint-disable-next-line import/no-cycle
import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import config from './config/index'
import getters from './getters'
// eslint-disable-next-line import/no-cycle
import permission from './auth/permission'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    config,
    permission,
    'app-ecommerce': ecommerceStoreModule,
  },
  getters,
  strict: process.env.DEV,
})
